import { useParams } from "react-router-dom";
import EventsAsExhibitor from "../../Components/EventsViews/EventsAsExhibitor";
import EventsAsOrganizer from "../../Components/EventsViews/EventsAsOrganizer";
import "../Styles/EventsPage.css"
export default function EventsPage(){
  const {role} = useParams()
  return <>
  {role==='organizer'?<EventsAsOrganizer/>:<EventsAsExhibitor/>}
  </>
}